/**
 * NASHE FAQ - Accordion Toggle
 */
(function() {
  'use strict';

  function initFaqAccordion() {
    var sections = document.querySelectorAll('.nashe-faq');

    sections.forEach(function(section) {
      var triggers = section.querySelectorAll('.nashe-faq__trigger');

      triggers.forEach(function(trigger) {
        trigger.addEventListener('click', function() {
          var item = trigger.closest('.nashe-faq__item');
          var isOpen = item.getAttribute('data-open') === 'true';

          // Close all items in the same accordion
          var accordion = item.closest('.nashe-faq__accordion');
          var items = accordion.querySelectorAll('.nashe-faq__item');
          items.forEach(function(i) {
            i.setAttribute('data-open', 'false');
          });

          // Toggle current item
          if (!isOpen) {
            item.setAttribute('data-open', 'true');
          }
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFaqAccordion);
  } else {
    initFaqAccordion();
  }

  document.addEventListener('shopify:section:load', function(e) {
    if (e.target.querySelector('.nashe-faq')) {
      initFaqAccordion();
    }
  });
})();
